import { PropsWithChildren } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY ?? '');

const StripePaymentFormWrapper = ({ children }: PropsWithChildren) => {
	return <Elements stripe={stripePromise}>{children}</Elements>;
};

export default StripePaymentFormWrapper;
